import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetExpenseCategory_Result } from '@typeDefs/expenses/responses/expenses';
import { FileAttachmentGetList_Result, HRUser, HRAttachmentsBySubmissionID_Result } from '@typeDefs/employee/responses/employee';
import { ApiResponse, ApiDataResponse } from '@shared/model/api-response.model';
import { ADGetUsersByPRCoAndPRGroup_Result } from '@typeDefs/admin/responses/admin';
import { SimpleLookupResult } from '@typeDefs/general/general';

@Injectable({
  providedIn: 'root',
})
export class EmployeeApiService {
  private readonly http = inject(HttpClient);

  getCategory(): Observable<GetExpenseCategory_Result[]> {
    const url = '/Employee/CatgGet';
    return this.http.get<GetExpenseCategory_Result[]>(url);
  }

  catgAddEdit(expenseCatgID: number, expenseCatgName: string, isActive: boolean): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/CatgAddEdit', {
      expenseCatgID: expenseCatgID,
      expenseCatgName: expenseCatgName,
      isActive: isActive,
    });
  }

  checkForDuplicateCCs(searchText: string): Observable<ApiDataResponse<HRUser[]>> {
    const params = new HttpParams().set('lastFourCCDigits', searchText);
    return this.http.get<ApiDataResponse<HRUser[]>>('/Employee/CheckForDuplicateCCs', { params: params });
  }

  catgDelete(expenseCatgID: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/CatgDelete', {
      expenseCatgID: expenseCatgID,
    });
  }

  getFileAttachmentBinary(fileAttachmentID: string) {
    const url = '/Employee/GetFileAttachmentBinary';
    const params = new HttpParams().set('fileAttachmentID', fileAttachmentID);
    return this.http.get<string>(url, { params: params });
  }

  getFileAttachmentList(requestParam: string) {
    const url = '/Employee/GetFileAttachmentList?' + requestParam;
    return this.http.get<FileAttachmentGetList_Result[]>(url);
  }

  getFileAttachmentData(fileAttachmentID: string): Observable<Blob> {
    const url = '/Employee/GetFileAttachmentData';
    const params = new HttpParams().set('fileAttachmentID', fileAttachmentID);

    return this.http.get(url, { params: params, responseType: 'blob' });
  }

  removeFileAttachment(fileAttachmentID: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/RemoveFileAttachment', {
      fileAttachmentID: fileAttachmentID,
    });
  }

  updateHRUser(user: ADGetUsersByPRCoAndPRGroup_Result): Observable<ApiDataResponse<{ matchingCCUsers: string }>> {
    return this.http.post<ApiDataResponse<{ matchingCCUsers: string }>>('/Employee/UpdateHRUser', user);
  }

  getFilingStatus(useConfigSetting?: boolean): Observable<SimpleLookupResult[]> {
    let params = new HttpParams();
    if (useConfigSetting !== undefined) {
      params = params.set('useConfigSetting', String(useConfigSetting));
    }
    return this.http.get<SimpleLookupResult[]>('/Employee/GetFilingStatus', { params });
  }

  getAttachmentsBySubmissionID(submissionGuid: string): Observable<HRAttachmentsBySubmissionID_Result[]> {
    const url = '/Employee/GetAttachmentsBySubmissionID';
    const params = new HttpParams().set('submissionGuid', submissionGuid);
    return this.http.get<HRAttachmentsBySubmissionID_Result[]>(url, { params });
  }

  updateServiceHubAdmins(user: ADGetUsersByPRCoAndPRGroup_Result): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/UpdateServiceHubAdmins', user);
  }
  sendFileAttachmentRawDataToVP(
    moduleID: number,
    recordKeyID: number,
    fileAttachmentType: string,
    submissionGuid?: any,
    descriptionList?: string,
    fileDescription?: string,
    attachmentType?: string
  ): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Document/SendFileAttachmentRawDataToVP', {
      moduleID: moduleID,
      recordKeyID: recordKeyID,
      fileAttachmentType: fileAttachmentType,
      submissionGuid: submissionGuid,
      descriptionList: descriptionList,
      fileDescription: fileDescription,
      attachmentType: attachmentType,
    });
  }

}
